var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4084_26274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 8.7513V10.0013C18.3332 13.9297 18.3332 15.8939 17.1128 17.1142C15.8924 18.3346 13.9282 18.3346 9.99984 18.3346C6.07147 18.3346 4.10728 18.3346 2.88689 17.1142C1.6665 15.8939 1.6665 13.9297 1.6665 10.0013C1.6665 6.07293 1.6665 4.10875 2.88689 2.88836C4.10728 1.66797 6.07147 1.66797 9.99984 1.66797H11.2498",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 11.6654L7.33091 9.86847C7.92428 9.15643 8.22096 8.80041 8.61127 8.80041C9.00159 8.80041 9.29827 9.15643 9.89164 9.86847L10.1087 10.1289C10.7021 10.841 10.9987 11.197 11.3891 11.197C11.7794 11.197 12.0761 10.841 12.6694 10.1289L14.1668 8.33203",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8335,
    cy: 4.16797,
    rx: 2.5,
    ry: 2.5,
    stroke: "#0F172A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4084_26274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphNew);
export default __webpack_public_path__ + "static/media/graph-new.40f2c304b222d36d77a64bd468ea8ecd.svg";
export { ForwardRef as ReactComponent };